module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('dl', {
    staticClass: "picture"
  }, [_c('dt', [_c('img', {
    staticClass: "img_img",
    attrs: {
      "src": _vm.basic_info.pic,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "show_part"
  }, [_c('ul', {
    staticClass: "part_list clearfix"
  }, [_c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("First Name＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.first_name))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Last Name＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.last_name))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Teacher Name＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.nick_name))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Birthday＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.birthday))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Nationality＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.selectShow.country))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Zoom account＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.zoom_id))])]), _vm._v(" "), _c('li', {
    staticClass: "width490"
  }, [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Skype ID")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.skype_id))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Computer's Operating Systerm＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.pc_type))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Country Code＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.country_code))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Phone Number＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.mobile))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Your Current Time Zone＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.selectShow.time_zone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "show_part"
  }, [_c('h3', {
    staticClass: "interests_tit"
  }, [_vm._v("The country, state, and city you choose will automatically generate your time zone and zip code.")]), _vm._v(" "), _c('ul', {
    staticClass: "part_list clearfix"
  }, [_c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Country＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.selectShow.country))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("State＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.changeShow.state))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("City＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.city))])]), _vm._v(" "), _c('li', {
    staticClass: "width490"
  }, [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Street＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.street))])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "part_tit"
  }, [_vm._v("Zip Code＊")]), _vm._v(" "), _c('div', {
    staticClass: "part_cont"
  }, [_vm._v(_vm._s(_vm.basic_info.z_code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "interest"
  }, [_c('h3', {
    staticClass: "interests_tit"
  }, [_vm._v("The background and interests below will help our students get to know you better.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "item_left"
  }, [_vm._v("Background＊")]), _vm._v(" "), _c('ul', {
    staticClass: "background_list clearfix"
  }, _vm._l((_vm.background), function(item, index) {
    return _c('li', {
      staticClass: "active"
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "item_left"
  }, [_vm._v("Interests＊")]), _vm._v(" "), _c('ul', {
    staticClass: "background_list clearfix"
  }, _vm._l((_vm.interests), function(item, index) {
    return _c('li', {
      staticClass: "active"
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_c('div', {
    staticClass: "picture_decoration"
  }, [_c('p', [_vm._v("Please upload a photo of yourself here. ")]), _vm._v(" "), _c('p', [_vm._v("This photo will be used for your teacher profile page.")]), _vm._v(" "), _c('p', [_vm._v("Your photo should be professional, and have adequate lighting. Don't forget to smile!")]), _vm._v(" "), _c('p', [_vm._v("The photo may be in jpg or png formats, and the size should be 120 x 120.")])]), _vm._v(" "), _c('div', {
    staticClass: "picture_sample"
  }, [_c('div', {
    staticClass: "picture_img"
  }, [_c('img', {
    attrs: {
      "src": require("@img/user_img.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Sample profile picture")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "edit"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Edit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8e9010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/onboarding/info_pre.vue
// module id = 845
// module chunks = 1